// @flow

import React, { type Element } from 'react'
import { Box, Grid, Typography } from '@material-ui/core'
import { green } from '../../Common/constants'
import EditIcon from '@material-ui/icons/Edit'
import { grey } from '@material-ui/core/colors'

type Props = {|
  title: string,
  content: string,
  handleEdit: () => void,
|}

function StaticField({ title, content, handleEdit }: Props): Element<typeof React.Fragment> {
  return (
    <>
      <Box pb={1} pt={2} width={1}>
        <Grid container direction="row" justify="space-between">
          <Box color={grey[600]}>
            <Typography component="span">{title}</Typography>
          </Box>
          <Box display="flex" style={{ cursor: 'pointer' }} onClick={handleEdit}>
            <EditIcon style={{ color: green }} fontSize="small" />
            <Box component="span" pl={0.5} color={green} fontWeight="fontWeightMedium" my="auto">
              <Typography component="span" variant="body2">
                Edit
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Box>
      <Box borderBottom={1} color={grey[300]} pb={2}>
        <Grid container direction="row">
          <Box color={grey[900]} fontWeight="fontWeightRegular">
            <Typography component="span" variant="body2">
              {content}
            </Typography>
          </Box>
        </Grid>
      </Box>
    </>
  )
}

export default StaticField
